import { boot } from 'quasar/wrappers';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

const bugsnag = Bugsnag.start({
  apiKey: process.env.BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginVue()],
  appVersion: process.env.VERSION,
  releaseStage: process.env.RELEASE,
  // enabledReleaseStages: ['production'],
});

export default boot(({ app }) => {
  app.use(bugsnag.getPlugin('vue'));
});

export {
  bugsnag,
};
